(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingrediant-section"] && !window.DesignMode) return;
  try {
    
  $(".bottom_main_wrapper .show_all_ingrediant").click(function() {
    $(this).hide();
    $(this).parents(".sidebar_content").find(".side_content").slideDown();
    $(this).parents(".sidebar_content").find(".hide_all_ingrediant").show();
    
});

$(".bottom_main_wrapper .hide_all_ingrediant").click(function() {
    $(this).hide();
    $(this).parents(".sidebar_content").find(".side_content").hide();
        $(this).parents(".sidebar_content").find(".show_all_ingrediant").show();
    
    
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["more-information"] && !window.DesignMode) return;
  try {
    
  $(".more_information_wrapper h2").click(function() {
    var aria_expanded = $(this).attr("aria-expanded");
    if(aria_expanded == 'true'){
      $(this).attr("aria-expanded","false");
       $(this).removeClass("active");
    $(this).parents(".more_information_wrapper").find(".bottom_content_main").slideUp();
    }else{
       $(this).attr("aria-expanded","true");
       $(this).addClass("active");
    $(this).parents(".more_information_wrapper").find(".bottom_content_main").slideDown();
    }
   
    
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["RQ-gratitude"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function() {
    let modalTimeout; // Declare a variable to store the timeout ID

    $('.stripe_image').on('click', function() {
      const desktopImage = $(this).data('img-desktop'); // Get desktop image URL
      const mobileImage = $(this).data('img-mobile');   // Get mobile image URL
      const headingText = $(this).data('heading');      // Get heading text

      // Update the src attributes of the modal images
      $('#modalImageDesktop').attr('src', desktopImage);
      $('#modalImageMobile').attr('src', mobileImage);

      // Update the modal heading
      $('#modalHeading').html(headingText);

      // Clear any existing timeout to avoid conflicts
      clearTimeout(modalTimeout);

      // Show the modal
      $('#stripeModal').fadeIn().css('display', 'flex');

      // Set a new timeout for auto-close
      modalTimeout = setTimeout(function() {
        $('#stripeModal').fadeOut();
      }, 3500);
    });

    // Close modal when the close button is clicked
    $('#closeModal').on('click', function() {
      // Clear the timeout to avoid auto-close
      clearTimeout(modalTimeout);
      $('#stripeModal').fadeOut();
    });

    // Close modal when clicking outside of the modal content
    $(window).on('click', function(event) {
      if ($(event.target).is('#stripeModal')) {
        // Clear the timeout to avoid auto-close
        clearTimeout(modalTimeout);
        $('#stripeModal').fadeOut();
      }
    });

    // Add image shadow effect in intervals
    let index = 0;
    const elements = $('.stripe_image .image_wrapper');
    const totalElements = elements.length;

    setInterval(function() {
      elements.removeClass('image_shadow');
      $(elements[index]).addClass('image_shadow');
      index = (index + 1) % totalElements;
    }, 2000);
  });

  } catch(e) { console.error(e); }
})();
})();
